<!-- <div class="card mb-5">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{data.title}}</h4>
    </div>
  </div>
  <div class="card-body">


    <div id="{{data.widgetId}}" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'" style="min-height: 200px; flex-grow: 1;"></div>
  </div>
</div> -->

<div class="card mb-5">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data.title }}</h4>
    </div>
  </div>
  <div class="card-body">
    <ng-container *ngIf="!hasError; else errorBlock">
      <div id="{{ data.widgetId }}" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'" style="min-height: 200px; flex-grow: 1;"></div>
    </ng-container>

    <ng-template #errorBlock>
      <app-data-error [message]="errorMessage" />
    </ng-template>
  </div>
</div>

